import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { ChimeraApiConfiguration, IChimeraApiConfigurationParams } from './chimera-api-configuration';

@NgModule()
export class ChimeraApiModule {
  constructor(@Optional() @SkipSelf() parentModule: ChimeraApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ChimeraApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }

  static forRoot(params: IChimeraApiConfigurationParams): ModuleWithProviders<ChimeraApiModule> {
    return {
      ngModule: ChimeraApiModule,
      providers: [{ provide: ChimeraApiConfiguration, useValue: params }],
    };
  }
}
